import React from 'react';
import PAPageView from './PAPage.View.tsx';

const PAPage = () => {
  return <PAPageView />;
};

export default PAPage;
